import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type PresentCard = {
  present_card_id?: number; // 선물 카드 idx
  title?: string;
  category_name?: string;
  image_url?: string;
  order?: number;
  is_show?: string;
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] PresentCard
   * --
   */
  getPresentCards: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_PRESENT_CARD, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] PresentCard
   * --
   */
  getPresentCard: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_PRESENT_CARD, {
        present_card_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] PresentCard
   * --
   */
  createPresentCard: async (body: PresentCard) => {
    try {
      const res = await $http.post(APIConstant.CREATE_PRESENT_CARD, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] PresentCard
   * --
   */
  updatePresentCard: async (body: PresentCard) => {
    try {
      const { present_card_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_PRESENT_CARD, {
        present_card_id: present_card_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] PresentCard
   * --
   */
  deletePresentCard: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_PRESENT_CARD, {
        present_card_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
  /**
   * [PUT] PresentCard
   * --
   */
  upsertPresentCard: async (body: PresentCard[]) => {
    try {
      const res = await $http.bulk(
        APIConstant.UPSERT_PRESENT_CARD,
        body,
        'PUT'
      );
      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
